import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { ChatEvent, ChatMessage } from '@iot-platform/models/common';
import { DateFormatPipe, LinkifyPipe } from '@iot-platform/pipes';

@Component({
  imports: [MatIcon, FlexLayoutModule, DateFormatPipe, MatButtonModule, LinkifyPipe],
  selector: 'iot-platform-ui-chat-message',
  templateUrl: './chat-message.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./chat-message.component.scss']
})
export class ChatMessageComponent {
  message = input.required<ChatMessage>();
  dispatchAction = output<ChatEvent>();
}
